module.exports = __webpack_public_path__ + "img/rain.9ab01c46.jpg";